import React, { Component } from "react";
import { Container, Menu, Dropdown } from "semantic-ui-react";
import { NavLink } from "react-router-dom";
import { withTranslation } from "react-i18next";
import i18n from "./../i18n";
import LanguageSelector from "../components/LanguageSelector";
import moment from "moment";

const logo = require("../images/logowhite.svg");

class FixedMenu extends Component {
  constructor(props) {
    super(props);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.state = {
      lang: localStorage.getItem("lang"),
    };
  }
  handleLanguageChange(e, data) {
    i18n.changeLanguage(data.value);
    localStorage.setItem("lang", data.value);
    moment.locale(data.value);
    this.setState({ lang: data.value });
    window.dispatchEvent(new Event("language-changed"));
  }
  render() {
    return (
      <Menu fixed="top" size="large" className="header-menu">
        <Container>
          <Menu.Item as={NavLink} to="/">
            <img alt="logo" src={logo.default} />
          </Menu.Item>
          <Menu.Menu position="right">
            <Menu.Item>
              <Dropdown
                style={{ background: "#6abf48", color: "white" }}
                button
                text={this.props.name}
              >
                <Dropdown.Menu>
                  <Dropdown.Item as={NavLink} to="/">
                    {this.props.t("App.dashboard")}
                  </Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/account-details">
                    {this.props.t("App.accountDetails")}
                  </Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/download">
                    {this.props.t("App.downloadApplication")}
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    as={NavLink}
                    to="/logout"
                    onClick={() => this.props.logout()}
                  >
                    {this.props.t("App.logout")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Menu.Item>
            <Menu.Item>
              <LanguageSelector
                lang={this.state.lang}
                handleLanguageChange={this.handleLanguageChange}
              />
            </Menu.Item>
          </Menu.Menu>
        </Container>
      </Menu>
    );
  }
}

export default withTranslation()(FixedMenu);
